var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('render-data',{attrs:{"renderClass":"items-center","innerClass":"it-tag default","value":_vm.number}})}
var staticRenderFns = []

export { render, staticRenderFns }